export default __webpack_public_path__ + "6ca3f807f144da5b36f276c8e6e9b84f.png";